(function () {
  var STORAGE_KEY = 'ak_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function getHandle(el) {
    var link = el.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function buildButton(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-card__wishlist-btn';
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('data-product-id', handle);
    btn.setAttribute('aria-label', 'Zum Merkzettel hinzufügen');

    var active = getWishlist().indexOf(handle) !== -1;
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (active) btn.classList.add('is-active');

    btn.innerHTML =
      '<img class="wishlist-icon wishlist-icon--outline" src="https://cdn.shopify.com/s/files/1/0550/1042/7136/files/heart-outline.png?v=1783694742" alt="" width="18" height="18">' +
      '<img class="wishlist-icon wishlist-icon--filled" src="https://cdn.shopify.com/s/files/1/0550/1042/7136/files/heart-filled.png?v=1783694516" alt="" width="18" height="18">';

    return btn;
  }

  function injectButtons() {
    document.querySelectorAll('.snize-product').forEach(function (el) {
      if (el.querySelector('.product-card__wishlist-btn')) return;
      var handle = getHandle(el);
      if (!handle) return;
      el.appendChild(buildButton(handle));
    });
  }

  var observer = new MutationObserver(injectButtons);
  observer.observe(document.body, { childList: true, subtree: true });

  injectButtons();
})();